import React from 'react';
import Navbar1 from '../../Navbar/Navbar1/Navbar1';
import Footer from '../../Footer/Footer';
import './Services1.css';
import { FiCpu, FiTrendingUp, FiMonitor, FiActivity, FiSettings, FiZap, FiDollarSign, FiAward, FiEye } from 'react-icons/fi';
import { FaGasPump, FaLeaf, FaClock, FaShieldAlt, FaCheckCircle, FaChartLine, FaBolt, FaBrain, FaEye, FaCloudSun, FaShip, FaMapMarkedAlt } from 'react-icons/fa';



const Services1 = ({ onNavigate }) => {
  return (
    <>
      <Navbar1 onNavigate={onNavigate} />
      <div className="services1-hero">
        <div className="services1-hero-content">
          <span className="services1-logo"> Shipshape Captain™ </span> 
          <h1>
            Trillions of Possibilities.<br />
            <span className="highlight">One Optimum Voyage.</span>
          </h1>
          <p className="services1-subtext">
            Shipshape Captain™ is AI Shipshape’s flagship platform for real-time voyage performance optimisation,
            combining AI, dynamic weather intelligence, and a continuously evolving digital twin of your vessel.
          </p>
          <p className="services1-subtext">
            At the core lies our patent-pending routing and RPM control engine, designed to analyse trillions of
            possible route and speed combinations—drawing from both live onboard data and high-resolution forecasted weather.
          </p>
          <button className="services1-btn" onClick={() => onNavigate('contact')}>Schedule Demo</button>
        </div>
      </div>

      {/* Optimizer Section with React Icons */}
      <div className="services1-optimizer-section">
        <div className="optimizer-card">
          <p className="optimizer-heading">Simultaneously optimises multiple voyage parameters</p>
          <div className="optimizer-icons">
            <div className="optimizer-item">
              <FaGasPump className="optimizer-icon" />
              <p><strong>Fuel consumption</strong></p>
            </div>
            <div className="optimizer-item">
              <FaLeaf className="optimizer-icon" />
              <p><strong>Emissions reduction</strong></p>
            </div>
            <div className="optimizer-item">
              <FaClock className="optimizer-icon" />
              <p><strong>Time efficiency</strong></p>
            </div>
            <div className="optimizer-item">
              <FaShieldAlt className="optimizer-icon" />
              <p><strong>Safety</strong></p>
            </div>
            <div className="optimizer-item">
              <FaCheckCircle className="optimizer-icon" />
              <p><strong>Compliance</strong></p>
            </div>
            <div className="optimizer-item">
              <FaChartLine className="optimizer-icon" />
              <p><strong>CII performance</strong></p>
            </div>
          </div>
        </div>
      </div>


     
            <div className="digital-twin-section">
            <div className="digital-twin-content">
                <h5 className="digital-twin-label">Digital Twin Technology</h5>
                <h2 className="digital-twin-heading">Live Digital Twin<br />of Your Vessel</h2>
                <p className="digital-twin-subtext">
                Shipshape Captain™ creates a live digital twin of each vessel, continuously updated to simulate how your vessel truly performs under varying conditions.
                </p>
                <ul className="digital-twin-list">
                <li>✅ Trim and draft curves</li>
                <li>✅ Hydrostatic and propulsion data</li>
                <li>✅ Resistance profiles and fuel consumption maps</li>
                <li>✅ Fouling effects and engine degradation</li>
                <li>✅ Real-time sensor inputs and voyage history</li>
                </ul>
            </div>

            <div className="digital-twin-cards">
                <div className="twin-card"><FaBolt size={28} color="#0A6478" /><p>Real-time Processing</p></div>
                <div className="twin-card"><FaChartLine size={28} color="#0A6478" /><p>Performance Tracking</p></div>
                <div className="twin-card"><FaBrain size={28} color="#0A6478" /><p>Adaptive Learning</p></div>
                <div className="twin-card"><FaEye size={28} color="#0A6478" /><p>Live Monitoring</p></div>
            </div>
            </div>


        <div className="environmental-section">
        <h5 className="environmental-label">Environmental Intelligence</h5>
        <h2 className="environmental-heading">Live + Forecasted Environmental Data</h2>
        <p className="environmental-subtext">
            Our engine continuously evaluates real-time and forecasted environmental conditions to adapt proactively to changing conditions at sea.
        </p>

        <div className="environmental-grid">
            <div className="env-card">
            <FaCloudSun size={32} color="#0A6478" />
            <h4>Weather Conditions</h4>
            <p>Wind, waves, swell, and ocean currents</p>
            </div>
            <div className="env-card">
            <FaShip size={32} color="#0A6478" />
            <h4>Vessel Performance</h4>
            <p>Hull fouling and degradation tracking</p>
            </div>
            <div className="env-card">
            <FaShieldAlt size={32} color="#0A6478" />
            <h4>Navigation Safety</h4>
            <p>Marine advisories and routing constraints</p>
            </div>
            <div className="env-card">
            <FaMapMarkedAlt size={32} color="#0A6478" />
            <h4>Port Operations</h4>
            <p>Arrival windows and speed restrictions</p>
            </div>
        </div>
        </div>

        <div className="core-capabilities-section">
        <h2 className="core-heading">Core Capabilities</h2>
        <div className="core-cards-wrapper">
            <div className="core-card">
            <h4>AI Routing & RPM Control</h4>
            <p>Our engine simulates trillions of routing scenarios, adapting in real time to vessel condition, forecasted weather, and operational targets.</p>
            <ul>
                <li>Real-time route optimization</li>
                <li>Optimal RPM recommendations</li>
                <li>Weather-adaptive planning</li>
                <li>Multi-objective optimization</li>
            </ul>
            </div>
            <div className="core-card">
            <h4>Dynamic Speed Control</h4>
            <p>Move beyond static speed profiles with real-time feedback for optimal performance and fuel efficiency.</p>
            <ul>
                <li>Adaptive RPM for best SFOC</li>
                <li>Sea state impact compensation</li>
                <li>Just-In-Time arrival logic</li>
                <li>Schedule maintenance</li>
            </ul>
            </div>
            <div className="core-card">
            <h4>Performance Monitoring</h4>
            <p>Get live visibility and comprehensive post-voyage analysis with detailed performance insights and compliance reporting.</p>
            <ul>
                <li>Live fuel consumption tracking</li>
                <li>CII rating impact analysis</li>
                <li>Deviation alerts</li>
                <li>Charter compliance reports</li>
            </ul>
            </div>
        </div>
        </div>


        {/* <div className="modular-integration-section">
        <h2 className="modular-heading">Modular Integration with Shipshape Ecosystem</h2>
        <p className="modular-subtext">
            We seamlessly integrate with your existing systems and the broader Shipshape platform for
            comprehensive fleet management.
        </p>

        <div className="integration-card-wrapper">
            <div className="integration-card">
            <h4>Shipshape Platform Integration</h4>
            <ul>
                <li>Shipshape Chief™ – onboard data and hardware layer</li>
                <li>Shipshape IQ™ – fleet-wide predictive analytics</li>
                <li>Emissions Reporting & Compliance tools</li>
            </ul>
            </div>
            <div className="integration-card">
            <h4>Third-Party Compatibility</h4>
            <ul>
                <li>ECDIS and navigation systems</li>
                <li>Planning and PMS systems</li>
                <li>API-ready for custom integrations</li>
            </ul>
            </div>
        </div>
        </div> */}
         <div className="modular-integration-section">
        <h2 className="modular-heading">Seamless Integration with Your Maritime Data Ecosystem</h2>
        <p className="modular-subtext">
        We connect with your existing data sources and operational systems to deliver unified analytics, compliance insights, and fleet-wide intelligence.
        </p>

        <div className="integration-card-wrapper">
            <div className="integration-card">
            <h4>Shipshape Platform Integration</h4>
            <ul>
                <li>Shipshape Chief™ – centralized operational data management</li>
                <li>Shipshape IQ™ – fleet-wide predictive analytics</li>
                <li>Emissions Reporting & Compliance tools </li>
            </ul>
            </div>
            <div className="integration-card">
            <h4>Third-Party Compatibility</h4>
            <ul>
                <li>ECDIS and navigation systems</li>
                <li>Planning and PMS systems</li>
                <li>API-ready for custom integrations</li>
            </ul>
            </div>
        </div>
        </div>


        <div className="key-benefits-section">
        <h2 className="key-benefits-heading">Key Benefits</h2>
        <p className="key-benefits-subtext">
            Comprehensive advantages for modern shipping operations
        </p>

        <div className="key-benefits-grid">
            <div className="benefit-card">
            <div className="benefit-icon">
                <FiZap />
            </div>
            <h4>Real-time AI Optimization</h4>
            <p>Continuous routing and RPM optimization</p>
            </div>
            <div className="benefit-card">
            <div className="benefit-icon">
                <FiDollarSign />
            </div>
            <h4>Reduced Fuel Consumption</h4>
            <p>Lower costs and engine wear</p>
            </div>
            <div className="benefit-card">
            <div className="benefit-icon">
                <FiAward />
            </div>
            <h4>Improved CII Scores</h4>
            <p>Better environmental compliance</p>
            </div>
            <div className="benefit-card">
            <div className="benefit-icon">
                <FiEye />
            </div>
            <h4>Full Transparency</h4>
            <p>Complete visibility for all stakeholders</p>
            </div>
        </div>
        </div>


        <div className="smarter-voyages-section">
        <h2 className="smarter-heading">Smarter Voyages Start Here</h2>
        <p className="smarter-subtext">
            In a world of rising fuel prices, tightening carbon regulations, and increasingly dynamic commercial
            demands, Shipshape Captain™ helps you navigate smarter.
        </p>
        <p className="smarter-tagline">Don’t just plan a route—optimise it.</p>
        <button className="smarter-btn" onClick={() => onNavigate('contact')}>Schedule Demo</button>
        </div>


      <Footer onNavigate={onNavigate} />
    </>
  );
};

export default Services1;
